import { render } from "./UserSidebar.vue?vue&type=template&id=0d27a928&scoped=true"
import script from "./UserSidebar.vue?vue&type=script&lang=js"
export * from "./UserSidebar.vue?vue&type=script&lang=js"

import "./UserSidebar.vue?vue&type=style&index=0&id=0d27a928&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d27a928"]])

export default __exports__